import "./App.css";
import { configureStorage } from "./redux/configureStore";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/es/integration/react";
import { Navigate, Routes, Route } from "react-router-dom";
import RegistrationForm from "./components/registration-form/RegistrationForm";
import Enquiries from "./components/registration-form/Enquiries";
import GeneralEnquiry from "./components/registration-form/GeneralEnquiry";
import Voga from "./pages/voga/Voga";
import VogaEnquiry from "./pages/voga/VogaEnquiry";
import ContactForm from "./pages/contact-form/ContactForm";
import CorporateAffiliations from "./components/registration-form/CorporateAffiliations";
import AjivasanAct from "./components/registration-form/AjivasanAct";

// import PageUrl from "./components/registration-form/PageUrl";
import DanceWorkshop from "./components/forms/DanceWorkshop";
import PaymentForm from "./components/forms/PaymentForm";
import SummerWorkshopOnline from "./components/forms/SummerWorkshopOnline";
import SummerWorkshopOffline from "./components/forms/SummerWorkshopOffline";
import SummerWorkshopOnlinePayment from "./components/forms/SummerWorkshopOnlinePayment";
import SummerWorkshopOfflinePayment from "./components/forms/SummerWorkshopOfflinePayment";
import OnlineWorkshop from "./pages/online-workshop/OnlineWorkshop";
import OnlineWorkshopPayment from "./pages/online-workshop/OnlineWorkshopPayment";
import Workshop from "./pages/workshop/Workshop";
import WorkshopPayment from "./pages/workshop/WorkshopPayment";
import ShorttermCourses from "./pages/short-term-courses/ShorttermCourses";
import ShorttermCoursesPayment from "./pages/short-term-courses/ShorttermCoursesPayment";
import ShorttermCoursesOnline from "./pages/short-term-courses-online/ShorttermCoursesOnline";
import ShorttermCoursesOnlinePayment from "./pages/short-term-courses-online/ShorttermCoursesOnlinePayment";
import Kidsuniversity from "./pages/kidsuniversity/Kidsuniversity";
import Musicclasses from "./pages/courses/Musicclasses";
// vocal routes
import Vocal from "./pages/courses/Vocal";
import Vocals from "./pages/2024-forms/vocal/Vocals";
import ThaneVocals from "./pages/2024-forms/vocal/ThaneVocals";
import Bengaluru from "./pages/2024-forms/Bengaluru/Bengaluru";
import BengaluruEnrollment from "./pages/2024-forms/Bengaluru/BengaluruEnrollment";

import DevotionalSongs from "./pages/courses/vocal-course-forms/DevotionalSongs";
import HindustaniClassicalVocal from "./pages/courses/vocal-course-forms/HindustaniClassicalVocal";
import LightBollywoodVocal from "./pages/courses/vocal-course-forms/LightBollywoodVocal";
import WesternVocal from "./pages/courses/vocal-course-forms/WesternVocal";

// Instrumental routes
import Instrumental from "./pages/courses/Instrumental";
import InstrumentalDrum from "./pages/courses/instruments-course-forms/InstrumentalDrum";
import InstrumentalKeyboard from "./pages/courses/instruments-course-forms/InstrumentalKeyboard";
import InstrumentalDjembe from "./pages/courses/instruments-course-forms/InstrumentalDjembe";
import InstrumentalFlute from "./pages/courses/instruments-course-forms/InstrumentalFlute";
import InstrumentalTabla from "./pages/courses/instruments-course-forms/InstrumentalTabla";
import InstrumentalSitar from "./pages/courses/instruments-course-forms/InstrumentalSitar";
import InstrumentalGuitar from "./pages/courses/instruments-course-forms/InstrumentalGuitar";
import InstrumentalHarmonium from "./pages/courses/instruments-course-forms/InstrumentalHarmonium";

import Drum from "./pages/drum/Drum";
import Bachata from "./pages/bachata/Bachata";
// dance Routes
import Dance from "./pages/courses/Dance";
import DanceBachata from "./pages/courses/dance-course-forms/DanceBachata";
import DanceKathak from "./pages/courses/dance-course-forms/DanceKathak";
import DanceJazzFusion from "./pages/courses/dance-course-forms/DanceJazzFusion";
import DanceBollyHop from "./pages/courses/dance-course-forms/DanceBollyHop";
import DanceBharatanatyam from "./pages/courses/dance-course-forms/DanceBharatanatyam";
import Garba from "./pages/courses/dance-course-forms/Garba";

import Onlineclass from "./pages/onlineclass/Onlineclass";
import Privatetuitions from "./pages/privatetuitions/Privatetuitions";
import HindustaniClassicalVocalClasses from "./pages/classes-same-form/HindustaniClassicalVocalClasses";
import WesternVocalsMusicClasses from "./pages/classes-same-form/WesternVocalsMusicClasses";
import GuitarClasses from "./pages/classes-same-form/GuitarClasses";
import KeyboardClasses from "./pages/classes-same-form/KeyboardClasses";
import SitarClasses from "./pages/classes-same-form/SitarClasses";
import TablaClasses from "./pages/classes-same-form/TablaClasses";
import RegisterTeacher from "./pages/teachers-form/RegisterTeacher";
// import Enroll from "./pages/enroll-forms/Enroll";
// import EnrollOnlineClass from "./pages/enroll-forms/EnrollOnlineClass";
import EnrollTuition from "./pages/enroll-forms/EnrollTuition";
import MusicCompositionMasterclass from "./components/registration-form/MusicCompositionMasterclass";
import BharatanatyamWorkshop from "./components/registration-form/BharatanatyamWorkshop";
import DrumMasterclass from "./components/forms/drum-masterclass/DrumMasterclass";
import KathakResgister from "./components/registration-form/KathakResgister";

import EnrollBranches from "./pages/tution-enroll/EnrollBranches";
import HomeTuitions from "./pages/tution-enroll/HomeTuitions";
import EnrollTrinity from "./pages/tution-enroll/EnrollTrinity";
import EnrollExam from "./pages/tution-enroll/EnrollExam";
import InternalExamination from "./pages/tution-enroll/InternalExamination";
import EnrollPrivateTuitions from "./pages/tution-enroll/EnrollPrivateTuitions";
import EnrollOnlinePrivateclass from "./pages/tution-enroll/OnlinePrivateclass";


// book a demo
import Group from "./pages/book-demo/online-demo/Group";
import OnetoOne from "./pages/book-demo/online-demo/OnetoOne";
import DemoatHome from "./pages/book-demo/demo-at-comfort/DemoatHome";
import DemoatNearestbranch from "./pages/book-demo/demo-at-nearest-branch/DemoatNearestbranch";

import DanceWorkshopDiwali from "./pages/online-dance-workshop-diwali/DanceWorkshopDiwali";
import AjivasanDemo from "./components/registration-form/AjivasanDemo";
// import PaymentForm1 from "./components/registration-form/PaymentForm";
import PayUMoneyPayment from "./components/PayUMoneyPayment";
import EnrollonlineClass from "./pages/enroll-online-class/EnrollonlineClass";
import MusicProduction from "./pages/music-production/MusicProduction";
import NewMusicProduction from "./pages/music-production/NewMusicProduction";
import ProfessionalCoursesinger from "./pages/music-production/ProfessionalCoursesinger";
import VogaOptionOne from "./pages/2024-forms/voga-form/VogaOptionOne";
import VogaOptionTwo from "./pages/2024-forms/voga-form/VogaOptionTwo";

// 2024 dance pages
import KathakForm from "./pages/2024-forms/dance/Kathak";
import BollyHipHopForm from "./pages/2024-forms/dance/BollyHipHop";
import JazzForm from "./pages/2024-forms/dance/Jazz";
import SalsaForm from "./pages/2024-forms/dance/Salsa";
import DanceLatest from "./pages/2024-forms/dance/DanceLatest";
import Djevent from "./pages/dj-event/Djevent";

//  2025 forms
import HomeTuitionsEnquiry from "./pages/2025-forms/home-tuitions-enquiry/HomeTuitionsEnquiry";
import AjivasanUtsav from "./pages/2025-forms/ajivasanutshav/AjivasanUtsav";
import ProfessionalCourses from "./pages/2025-forms/ajivasanutshav/ProfessionalCourses";

const { persistor, store } = configureStorage();
function App({ formId }) {
  const renderContent = () => {
    if (!formId) {
      return (
        <Routes>
          <Route index element={<RegistrationForm />} />
          <Route path="/enquiry" element={<Enquiries />} />
          <Route path="/ajivasan-act" element={<AjivasanAct />} />
          <Route path="/ajivasan" element={<AjivasanDemo />} />
          <Route path="/testing" element={<PayUMoneyPayment />} />
          <Route path="/voga-forms" element={<Voga />} />
          <Route path="/voga-enquiry" element={<VogaEnquiry />} />
          <Route path="/general-enquiry" element={<GeneralEnquiry />} />
          <Route path="/contact-form" element={<ContactForm />} />
          <Route
            path="/corporate-affiliations"
            element={<CorporateAffiliations />}
          />
          <Route path="/home-tuition" element={<HomeTuitions />} />
          <Route path="/enroll-branches" element={<EnrollBranches />} />
          <Route path="/enroll-trinity" element={<EnrollTrinity />} />
          <Route path="/enroll-exam" element={<EnrollExam />} />
          <Route
            path="/internal-examination"
            element={<InternalExamination />}
          />
          <Route
            path="/enroll-private-tuition"
            element={<EnrollPrivateTuitions />}
          />
           <Route
            path="/enroll-online-private-class"
            element={<EnrollOnlinePrivateclass />}
          />
          {/* ---dance workshop forms */}
          <Route path="/dance-workshop" element={<DanceWorkshop />} />
          {/* ---No Courses Found ---- */}
          <Route path="/payment-form" element={<PaymentForm />} />
          {/* ---No Courses Found ---- */}
          {/* -----summer workshop online forms */}
          <Route
            path="/summer-workshop-online"
            element={<SummerWorkshopOnline />}
          />{" "}
          {/* ---No Courses Found ---- */}
          <Route
            path="/summer-workshop-online-payment"
            element={<SummerWorkshopOnlinePayment />}
          />
          {/* ---No Courses Found ---- */}
          {/* -----summer workshop offline forms */}
          <Route
            path="/summer-workshop-offline"
            element={<SummerWorkshopOffline />}
          />
          {/* ---No Courses Found ---- */}
          <Route
            path="/summer-workshop-offline-payment"
            element={<SummerWorkshopOfflinePayment />}
          />
          {/* ---No Courses Found ---- */}
          <Route
            path="/music-composition-masterclass"
            element={<MusicCompositionMasterclass />}
          />
          <Route
            path="/bharatanatyam-workshop"
            element={<BharatanatyamWorkshop />}
          />
          <Route path="/drum-masterclass" element={<DrumMasterclass />} />
          <Route path="/kathak-workshop" element={<KathakResgister />} />
          {/* ---------excel sheet forms no use-------- */}
          <Route path="/onlineworkshop" element={<OnlineWorkshop />} />
          <Route
            path="/onlineworkshop-payment"
            element={<OnlineWorkshopPayment />}
          />
          <Route path="/workshop" element={<Workshop />} />
          {/* ---No Courses Found ---- */}
          <Route path="/workshop-payment" element={<WorkshopPayment />} />
          {/* ---No Courses Found ---- */}
          <Route path="/short-term-courses" element={<ShorttermCourses />} />
          {/* ---No Courses Found ---- */}
          <Route
            path="/short-term-courses-payment"
            element={<ShorttermCoursesPayment />}
          />
          {/* ---No Courses Found ---- */}
          <Route
            path="/short-term-courses-online"
            element={<ShorttermCoursesOnline />}
          />
          {/* ---No Courses Found ---- */}
          <Route
            path="/short-term-courses-online-payment"
            element={<ShorttermCoursesOnlinePayment />}
          />
          {/* ---No Courses Found ---- */}
          <Route path="/musicclasses" element={<Musicclasses />} />
          <Route path="/onlineclass" element={<Onlineclass />} />{" "}
          {/* ---No Courses Pass ---- */}
          <Route path="/privatetuitions" element={<Privatetuitions />} />{" "}
          {/* ---No Courses Pass ---- */}
          <Route
            path="/hindustani-classical-vocal-classes"
            element={<HindustaniClassicalVocalClasses />}
          />{" "}
          {/* ---No Courses Pass ---- */}
          <Route
            path="/western-vocals-music-classes"
            element={<WesternVocalsMusicClasses />}
          />{" "}
          {/* ---No Courses Pass ---- */}
          <Route path="/guitar-classes" element={<GuitarClasses />} />
          <Route path="/keyboard-classes" element={<KeyboardClasses />} />
          <Route path="/sitar-classes" element={<SitarClasses />} />
          <Route path="/tabla-classes" element={<TablaClasses />} />
          {/* || top event id === 2  excel sheet forms  top 4 not working form*/}

          <Route path="/kidsuniversity" element={<Kidsuniversity />} />
          {/* vocal cources route start*/}
          <Route path="/vocal" element={<Vocal />} />
          <Route path="/vocals" element={<Vocals />} />
          <Route path="/thane-vocals" element={<ThaneVocals />} />
          <Route path="/bengaluru" element={<Bengaluru />} />
          <Route
            path="/bengaluru-enrollment"
            element={<BengaluruEnrollment />}
          />
          <Route path="/devotional-songs" element={<DevotionalSongs />} />
          <Route path="/western-vocal" element={<WesternVocal />} />
          <Route
            path="/light-bollywood-vocal"
            element={<LightBollywoodVocal />}
          />
          <Route
            path="/hindustani-classical-vocal"
            element={<HindustaniClassicalVocal />}
          />
          {/* vocal cources route end*/}
          {/* instrumental cources route start*/}
          <Route path="/instrumental" element={<Instrumental />} />
          <Route
            path="/instrumental-keyboard"
            element={<InstrumentalKeyboard />}
          />
          <Route
            path="/instrumental-guitar"
            element={<InstrumentalGuitar />}
          />
          <Route path="/instrumental-tabla" element={<InstrumentalTabla />} />
          <Route path="/instrumental-sitar" element={<InstrumentalSitar />} />
          <Route path="/instrumental-flute" element={<InstrumentalFlute />} />
          <Route
            path="/instrumental-djembe"
            element={<InstrumentalDjembe />}
          />
          <Route path="/instrumental-drum" element={<InstrumentalDrum />} />
          <Route
            path="/instrumental-harmonium"
            element={<InstrumentalHarmonium />}
          />
          {/* instrumental cources route end */}
          {/* dance cources route start*/}
          <Route path="/dance" element={<Dance />} />
          <Route path="/dance-bachata" element={<DanceBachata />} />
          <Route path="/dance-kathak" element={<DanceKathak />} />
          <Route path="/dance-jazz-fusion" element={<DanceJazzFusion />} />
          <Route path="/dance-bollyhop" element={<DanceBollyHop />} />
          <Route
            path="/dance-bharatanatyam"
            element={<DanceBharatanatyam />}
          />
          <Route path="/garba" element={<Garba />} />
          {/* dance cources route end*/}
          <Route path="/drum-form" element={<Drum />} />
          <Route path="/bachata-form" element={<Bachata />} />
          {/*---------same form---  */}
          {/* ---------teachers form ----------- */}
          <Route path="/register-teacher" element={<RegisterTeacher />} />
          {/* <Route path="/enroll" element={<Enroll />} /> */}
          {/* <Route
            path="/enroll-online-class"
            element={<EnrollOnlineClass />}
          /> */}
    
          <Route path="/enroll-tuition" element={<EnrollTuition />} />
          {/* book a demo */}
          <Route path="/online-demo-group" element={<Group />} />
          <Route path="/online-demo-one-to-one" element={<OnetoOne />} />
          <Route path="/demo-at-comfort-at-home" element={<DemoatHome />} />
          <Route
            path="/demo-at-nearest-branch"
            element={<DemoatNearestbranch />}
          />
          <Route
            path="/dance-workshop-diwali"
            element={<DanceWorkshopDiwali />}
          />
          <Route path="/online-group-class" element={<EnrollonlineClass />} />
          <Route path="/music-production" element={<MusicProduction />} />
          <Route path="/new-music-production" element={<NewMusicProduction />} />

          <Route
            path="/professional-course-singer"
            element={<ProfessionalCoursesinger />}
          />
          <Route
            path="/ajivasan-uthsav"
            element={<AjivasanUtsav/>}
          />
          <Route
            path="/professional-courses"
            element={<ProfessionalCourses/>}
          />
          {/* 2024 march routes */}
          <Route path="/voga-option-one" element={<VogaOptionOne />} />
          <Route path="/voga-option-two" element={<VogaOptionTwo />} />
          <Route path="/kathak-form" element={<KathakForm />} />
          <Route path="/salsa-form" element={<SalsaForm />} />
          <Route path="/jazz-form" element={<JazzForm />} />
          <Route path="/bolly-hip-hop-form" element={<BollyHipHopForm />} />
          <Route path="/dance-2024" element={<DanceLatest />} />
          <Route path="/djevent" element={<Djevent />} />
          <Route
            path="/home-tuitions-enquiry"
            element={<HomeTuitionsEnquiry />}
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      );
    }

    switch (formId) {
      case "enquiry":
        return <Enquiries />;
      case "ajivasan-act":
        return <AjivasanAct />;
      case "ajivasan":
        return <AjivasanDemo />;
      case "testing":
        return <PayUMoneyPayment />;
      case "voga-forms":
        return <Voga />;
      case "voga-enquiry":
        return <VogaEnquiry />;
      case "general-enquiry":
        return <GeneralEnquiry />;
      case "contact-form":
        return <ContactForm />;
      case "corporate-affiliations":
        return <CorporateAffiliations />;
      case "home-tuition":
        return <HomeTuitions />;
      case "enroll-branches":
        return <EnrollBranches />;
      case "enroll-trinity":
        return <EnrollTrinity />;
      case "enroll-exam":
        return <EnrollExam />;
      case "internal-examination":
        return <InternalExamination />;
      case "enroll-private-tuition":
        return <EnrollPrivateTuitions />;
      case "enroll-online-private-class":
        return <EnrollOnlinePrivateclass />;
      case "dance-workshop":
        return <DanceWorkshop />;
      case "payment-form":
        return <PaymentForm />;
      case "summer-workshop-online":
        return <SummerWorkshopOnline />;
      case "summer-workshop-online-payment":
        return <SummerWorkshopOnlinePayment />;
      case "summer-workshop-offline":
        return <SummerWorkshopOffline />;
      case "summer-workshop-offline-payment":
        return <SummerWorkshopOfflinePayment />;
      case "music-composition-masterclass":
        return <MusicCompositionMasterclass />;
      case "bharatanatyam-workshop":
        return <BharatanatyamWorkshop />;
      case "drum-masterclass":
        return <DrumMasterclass />;
      case "kathak-workshop":
        return <KathakResgister />;
      case "onlineworkshop":
        return <OnlineWorkshop />;
      case "onlineworkshop-payment":
        return <OnlineWorkshopPayment />;
      case "workshop":
        return <Workshop />;
      case "workshop-payment":
        return <WorkshopPayment />;
      case "short-term-courses":
        return <ShorttermCourses />;
      case "short-term-courses-payment":
        return <ShorttermCoursesPayment />;
      case "short-term-courses-online":
        return <ShorttermCoursesOnline />;
      case "short-term-courses-online-payment":
        return <ShorttermCoursesOnlinePayment />;
      case "musicclasses":
        return <Musicclasses />;
      case "onlineclass":
        return <Onlineclass />;
      case "privatetuitions":
        return <Privatetuitions />;
      case "hindustani-classical-vocal-classes":
        return <HindustaniClassicalVocalClasses />;
      case "western-vocals-music-classes":
        return <WesternVocalsMusicClasses />;
      case "guitar-classes":
        return <GuitarClasses />;
      case "keyboard-classes":
        return <KeyboardClasses />;
      case "sitar-classes":
        return <SitarClasses />;
      case "tabla-classes":
        return <TablaClasses />;
      case "kidsuniversity":
        return <Kidsuniversity />;
      case "vocal":
        return <Vocal />;
      case "vocals":
        return <Vocals />;
      case "thane-vocals":
        return <ThaneVocals />;
      case "bengaluru":
        return <Bengaluru />;
      case "bengaluru-enrollment":
        return <BengaluruEnrollment />;
      case "devotional-songs":
        return <DevotionalSongs />;
      case "western-vocal":
        return <WesternVocal />;
      case "light-bollywood-vocal":
        return <LightBollywoodVocal />;
      case "hindustani-classical-vocal":
        return <HindustaniClassicalVocal />;
      case "instrumental":
        return <Instrumental />;
      case "instrumental-keyboard":
        return <InstrumentalKeyboard />;
      case "instrumental-guitar":
      case "guitar": // Alias for guitar
        return <InstrumentalGuitar />;
      case "instrumental-tabla":
        return <InstrumentalTabla />;
      case "instrumental-sitar":
        return <InstrumentalSitar />;
      case "instrumental-flute":
        return <InstrumentalFlute />;
      case "instrumental-djembe":
        return <InstrumentalDjembe />;
      case "instrumental-drum":
        return <InstrumentalDrum />;
      case "instrumental-harmonium":
        return <InstrumentalHarmonium />;
      case "dance":
        return <Dance />;
      case "dance-bachata":
        return <DanceBachata />;
      case "dance-kathak":
        return <DanceKathak />;
      case "dance-jazz-fusion":
        return <DanceJazzFusion />;
      case "dance-bollyhop":
        return <DanceBollyHop />;
      case "dance-bharatanatyam":
        return <DanceBharatanatyam />;
      case "garba":
        return <Garba />;
      case "drum-form":
        return <Drum />;
      case "bachata-form":
        return <Bachata />;
      case "register-teacher":
        return <RegisterTeacher />;
      case "enroll-tuition":
        return <EnrollTuition />;
      case "online-demo-group":
        return <Group />;
      case "online-demo-one-to-one":
        return <OnetoOne />;
      case "demo-at-comfort-at-home":
        return <DemoatHome />;
      case "demo-at-nearest-branch":
        return <DemoatNearestbranch />;
      case "dance-workshop-diwali":
        return <DanceWorkshopDiwali />;
      case "online-group-class":
        return <EnrollonlineClass />;
      case "music-production":
        return <MusicProduction />;
      case "new-music-production":
        return <NewMusicProduction />;
      case "professional-course-singer":
        return <ProfessionalCoursesinger />;
      case "ajivasan-uthsav":
        return <AjivasanUtsav />;
      case "professional-courses":
        return <ProfessionalCourses />;
      case "voga-option-one":
        return <VogaOptionOne />;
      case "voga-option-two":
        return <VogaOptionTwo />;
      case "kathak-form":
        return <KathakForm />;
      case "salsa-form":
        return <SalsaForm />;
      case "jazz-form":
        return <JazzForm />;
      case "bolly-hip-hop-form":
        return <BollyHipHopForm />;
      case "dance-2024":
        return <DanceLatest />;
      case "djevent":
        return <Djevent />;
      case "home-tuitions-enquiry":
        return <HomeTuitionsEnquiry />;
      case "admission":
      default:
        return <RegistrationForm />;
    }
  };

  return (
    <div className="App">
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          {renderContent()}
        </PersistGate>
      </Provider>
    </div>
  );
}

export default App;
